/**
 * BookableResourceBlockoutService
 * Service for managing bookable resource blockout periods
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for bookable resource blockout CRUD operations with resource-specific and active queries
 */
export class BookableResourceBlockoutService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookableResourceBlockoutService.DEFAULT_SERVICE_PATH,
            basePath: BookableResourceBlockoutService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY RESOURCE ====================
    /**
     * Get all blockout periods for a specific bookable resource
     * @param resourceId - The bookable resource ID
     * @returns Array of bookable resource blockouts
     */
    async getByResource(resourceId) {
        const response = await this.getByResourceRaw(resourceId);
        return response.data ?? [];
    }
    /**
     * Get all blockout periods for a specific bookable resource with full response
     * @param resourceId - The bookable resource ID
     * @returns ResponseData with array of bookable resource blockouts
     */
    getByResourceRaw(resourceId) {
        const url = this.buildUrl(`by-resource/${resourceId}`);
        return this.http.get(url);
    }
    // ==================== GET ACTIVE ====================
    /**
     * Get all currently active blockout periods
     * @returns Array of active bookable resource blockouts
     */
    async getActive() {
        const response = await this.getActiveRaw();
        return response.data ?? [];
    }
    /**
     * Get all currently active blockout periods with full response
     * @returns ResponseData with array of active bookable resource blockouts
     */
    getActiveRaw() {
        const url = this.buildUrl('active');
        return this.http.get(url);
    }
}
BookableResourceBlockoutService.DEFAULT_SERVICE_PATH = 'booking-management';
BookableResourceBlockoutService.BASE_PATH = 'api/bookable-resource-blockouts';
//# sourceMappingURL=BookableResourceBlockoutService.js.map